import { useState } from 'react'
import { useFeatureFlag, Feature } from '../../../../../context/useFeatureFlag'
import { Bill, Subscription } from '../Bills'
import { CurrentSubscription } from './manage/CurrentSubscription'
import { ManageSubscriptionDialog } from './manage/ManageSubscriptionDialog'
import { SubscriptionError } from './manage/SubscriptionError'
import { SetupBillSubscription } from './SetupBillSubscription'
import { useActiveSubscription } from './useActiveSubscription'

type SmartPayActionsProps = {
    bill: Bill
    subscriptions: Subscription[]
}

export const SmartPayActions: React.FC<SmartPayActionsProps> = ({ bill, subscriptions }) => {
    const [manageDialogOpen, setManageDialogOpen] = useState(false)
    const smartPayEnabled = useFeatureFlag(Feature.SmartPay)
    const { subscription, hasSubscription } = useActiveSubscription(bill, subscriptions)

    const onClickManage = () => setManageDialogOpen(true)

    return (
        <>
            {smartPayEnabled && (
                <SetupBillSubscription bill={bill} hasSubscription={hasSubscription} />
            )}
            {smartPayEnabled && subscription && (
                <CurrentSubscription subscription={subscription} onClickManage={onClickManage} />
            )}
            {subscription?.error ? (
                <SubscriptionError
                    subscription={subscription}
                    generic
                    onClickManage={onClickManage}
                />
            ) : null}
            {subscription ? (
                <ManageSubscriptionDialog
                    open={manageDialogOpen}
                    onClose={() => setManageDialogOpen(false)}
                    subscription={subscription}
                />
            ) : null}
        </>
    )
}
